import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiFetch } from '@/domains/general/api/client';

import { overviewKeys } from './keys';
import type { OverviewBlock, OverviewConfigResponse } from './types';

/** Slaat de volledige lijst op; daarna toont de Overview meteen de nieuwe configuratie. */
export function useSaveOverviewConfig(perspectiveId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (blocks: OverviewBlock[]) =>
      apiFetch<OverviewConfigResponse>('/overview-config', {
        method: 'PUT',
        body: JSON.stringify({ blocks }),
      }),
    onSuccess: (data) => {
      qc.setQueryData(overviewKeys.config(perspectiveId), data);
    },
  });
}
